/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: BuiltinFieldsSection.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/14 @ 849
 * ---
 * Description:
 */

import { useEffect, useState }        from 'react';
import { DataRefType }                from '@revodigital/mpes';
import { mleDomainGqlClient }         from '../../../api/domain';
import { GET_BUILTINS_META }          from '../../../api/domain/queries.gql';
import { BuiltinMeta }                from '../../../entities';
import { OriginTypeSection, RefData } from './OriginTypeSection';
import { HasEditor }                  from '../../../common/props';
import { observer }                   from 'mobx-react';

interface Props extends HasEditor {}

export const BuiltinFieldsSection = observer((props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [refData, setRefData] = useState<RefData[]>([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const allBuiltins = (await mleDomainGqlClient.query({
        query: GET_BUILTINS_META,
        fetchPolicy: 'no-cache',
        variables: {
          id: props.editor.projectData.labelId,
        }
      })).data.getBuiltinMetaForLabel as BuiltinMeta[];

      // Map and set state
      setRefData(allBuiltins.map(it => {
        return {
          ref: {
            name: it.name,
            type: DataRefType.BUILTIN,
            usageCount: 0
          },
          value: it.value
        };
      }));

      setIsLoading(false);
    })();
  }, [setIsLoading, setRefData, props.editor.projectData]);

  return (
    <OriginTypeSection data={ refData } editor={ props.editor }
                       isLoading={ isLoading } title="Built-In"/>
  );
});